// extracted by mini-css-extract-plugin
module.exports = {"root":"MediaFeedList_root__9kovj","rootCarousel":"MediaFeedList_rootCarousel__DfPra"};